import React, { Component } from "react";
import PropTypes from "prop-types";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error) {
    this.setState({ error });
    if (
      process.env.NODE_ENV === "production" ||
      process.env.NODE_ENV === "staging"
    ) {
      // eslint-disable-next-line
      Rollbar.error(error);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="alert alert-danger" style={{ marginTop: "20px" }}>
          <h4 style={{ textTransform: "none" }}>
            An unexpected error occurred.{" "}
            <a
              href=""
              onClick={() => location.reload()}
              style={{ color: "yellow" }}
            >
              Try refreshing.
            </a>
          </h4>
          <p>Error: {this.state.error.message}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./app/modules/shared/components/ErrorBoundary/ErrorBoundary.jsx